import { Box, ChakraComponent, Heading } from '@chakra-ui/react';
import { ColorModeButton } from '@mono/chakra';
import { useEffect } from 'react';
import { useLayoutRefs } from '../refs/refs';

const MainContent: ChakraComponent<'main'> = ({ children, as, ...props }) => {
  const refs = useLayoutRefs();

  useEffect(() => {
    const layout = refs.layoutRef.current;
    const header = refs.headerRef.current;
    const content = refs.contentAreaRef.current;
    if (!layout || !header || !content) return;

    const updateHeight = () => {
      if (!layout || !header || !content) return;
      const contentHeight = layout.offsetHeight - header.offsetHeight;
      content.style.height = `${contentHeight}px`;
      console.log('updating layout height');
    };

    requestAnimationFrame(updateHeight);

    const resizeObserver = new ResizeObserver(() => {
      requestAnimationFrame(updateHeight);
    });

    resizeObserver.observe(layout);
    resizeObserver.observe(header);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <Box
      as="main"
      maxWidth={'100%'}
      flex={1}
      bg={'bg.subtle'}
      {...props}
      ref={refs.mainRef}
    >
      <Box
        width={'100%'}
        bg={'bg.panel'}
        px={{ base: 3, md: 4 }}
        py={3}
        borderBottom={'xs'}
        borderColor={'border'}
        display={'flex'}
        flexDirection={'row'}
        alignItems={'center'}
        gap={{ base: 2, md: 4 }}
        ref={refs.headerRef}
      >
        <Box
          flex={1}
          minWidth={0}
          display={'flex'}
          alignItems={'center'}
          gap={{ base: 2, md: 3 }}
          flexShrink={0}
        >
          <Box ref={refs.orgSwitcherRef}></Box>
          <Heading size={'xl'} as={'div'} ref={refs.headingRef}></Heading>
        </Box>
        <Box
          display={'flex'}
          alignItems={'center'}
          gap={{ base: 2, md: 3 }}
          flexShrink={0}
        >
          <Box ref={refs.headerRightRef}></Box>
          <Box
            ref={refs.profileInfoRef}
            display={'flex'}
            alignItems={'center'}
            justifyContent={'flex-end'}
          />
          <ColorModeButton />
        </Box>
      </Box>
      <Box
        p={2}
        ref={refs.contentAreaRef}
        id="content-area"
        position={'relative'}
      >
        {children}
      </Box>
    </Box>
  );
};

export default MainContent;
